import {
  CreatePlanningExportParams,
  GetPartnerPlanningShiftsResponse,
  PartnerClaimantsQueryResponse,
  PartnerWorkerInfiniteQueryResponse,
  PlannerShiftResponse,
  ShiftPlanningParams,
} from './partner-planner-service.types';
import { PartnerApiService } from './partner-api-service';

class PartnerPlannerService {
  constructor(private readonly partnerApiService: PartnerApiService) {}

  public async getShiftPlanningShifts({
    fromDate,
    company,
    branchOfficeIds,
    departmentIds,
    pageParam,
    pageSizeParam,
    jobType,
    filledStatus,
    workerId,
    isFreelance,
    isTempWork,
  }: ShiftPlanningParams) {
    const response = await this.partnerApiService.get<GetPartnerPlanningShiftsResponse>({
      params: {
        page: pageParam,
        pageSize: pageSizeParam,
        fromDate: fromDate?.toISO(),
        companyId: company,
        branchOffices: branchOfficeIds,
        departments: departmentIds,
        jobType: jobType,
        filledStatus,
        workerId,
        isFreelance,
        isTempWork,
      },
      path: 'shift-planning/shifts',
    });

    return response;
  }

  public async getShift(shiftId: string): Promise<PlannerShiftResponse> {
    return this.partnerApiService.get<PlannerShiftResponse>({ path: `planning/${shiftId}` });
  }

  public async getShiftClaimants(
    shiftId: string,
    page: number
  ): Promise<PartnerClaimantsQueryResponse> {
    return this.partnerApiService.get<PartnerClaimantsQueryResponse>({
      path: `planning/${shiftId}/claimants`,
      params: {
        page,
        pageSize: 25,
      },
    });
  }

  public async getShiftWorkers(
    shiftId: string,
    fullNameSearch: string | undefined,
    page: number,
    pageSize: number
  ): Promise<PartnerWorkerInfiniteQueryResponse> {
    return this.partnerApiService.get<PartnerWorkerInfiniteQueryResponse>({
      path: `planning/${shiftId}/workers`,
      params: {
        page,
        pageSize,
        fullNameSearch,
      },
    });
  }

  public async claimShift(workerId: string, shiftId: string): Promise<void> {
    return this.partnerApiService.update({ path: `planning`, body: { workerId, shiftId } });
  }

  public async cancelShift(shiftClaimId: string): Promise<void> {
    return this.partnerApiService.update({ path: `planning/cancel/${shiftClaimId}` });
  }

  public createPlanningExport = async (params: CreatePlanningExportParams): Promise<void> => {
    return await this.partnerApiService.create<void>({
      path: 'shift-planning/export',
      body: params,
    });
  };
}

export { PartnerPlannerService };
